import { Button } from "@/components/ui/button";
import { ClipboardPlus } from "lucide-react";
import { logInterventionWithToast } from "@/utils/interventionLogger";

/**
 * Reusable "Log to Tracker" button for calculator tools (APGAR, CIWA, BSA/Burn,
 * Code Timer, etc). Calls logInterventionWithToast with the provided entry.
 *
 * @param {Object}   entry         - { type, name, dose, route, notes, time }
 * @param {String}   successLabel  - Optional toast title override
 * @param {String}   testId        - data-testid override
 * @param {Boolean}  disabled      - disable when input is incomplete
 * @param {String}   variant       - "default" | "outline" | "ghost"
 * @param {String}   className     - extra classes
 * @param {String}   label         - button text (default "Log to Tracker")
 */
export default function LogToTrackerButton({
  entry,
  successLabel,
  testId = "log-to-tracker",
  disabled = false,
  variant = "default",
  className = "",
  label = "Log to Tracker",
}) {
  return (
    <Button
      variant={variant}
      disabled={disabled}
      className={`gap-2 ${className}`}
      onClick={() => logInterventionWithToast(entry, successLabel)}
      data-testid={testId}
    >
      <ClipboardPlus className="w-4 h-4" />
      {label}
    </Button>
  );
}
